import { AppLayout } from "../../components/layout/Header";
import { MessagesDesk } from "../../components/messaging";

export default function BrokerMessages() {
  return (
    <AppLayout variant="broker">
      <MessagesDesk deskRole="broker" />
    </AppLayout>
  );
}
